import { FunctionComponent, useContext } from "react";

import { AppContext } from "../../../context/AppContext";
import ScrollableContainer from "../../../layout/scrollable-container";
import Footer from "../../../components/footer";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { ERROR_CODE_401, ERROR_CODE_500, UNAUTHORIZED_ERROR_MESSAGE } from "../../../typings";

import sendError from "../../../utils/sendError";
import { sendSentryError } from "../../../lib/sentry";
import { VectorWrapper } from "../../post-transfer/styles";
import errorVector from "./errorVector.svg";
import { HeadlineMedium } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";

const ErrorPane: FunctionComponent = (props: any) => {
  const { isWebview } = useContext(AppContext);

  const sendErrorHandler = () => {
    if (props.error.message === UNAUTHORIZED_ERROR_MESSAGE) {
      sendError(
        {
          errorCode: ERROR_CODE_401,
          errorMessage: `Invalid token. Please launch Bridge again with a valid token.`,
        },
        isWebview,
      );
    } else {
      const errorId = sendSentryError(props.error);
      sendError(
        {
          errorCode: ERROR_CODE_500,
          errorMessage: `An unexpected error occurred in the Bridge. ${errorId ? `Error Reference: ${errorId}` : ""}`,
        },
        isWebview,
      );
    }
  };
  return (
    <TransitionWrapper>
      <ScrollableContainer name="consent-pane-content">
        <Container>
          <HeadlineMedium $textAlign="center">Something went wrong</HeadlineMedium>
          <p className="text-center form-description">
            An unexpected error occurred. Please exit this screen and try again.
          </p>
          <VectorWrapper>
            <img src={errorVector} alt="error" />
          </VectorWrapper>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={sendErrorHandler} name="exit-manifest" size="large">
          Exit
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ErrorPane;
